import Vue from 'vue'

import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import './assets/iconfont/iconfont.css';
import './styles/element-variables.scss'
import './styles/index.scss'

import * as filters from './filters' // global filters

import VueElementExtends from 'vue-element-extends'
import 'vue-element-extends/lib/index.css'
import moment from 'moment' // 导入文件
Vue.prototype.$moment = moment; // 赋值使用

Vue.use(VueElementExtends)

import vueWaves from '@/directive/waves/index' // 水波纹指令
Vue.use(vueWaves)
import permission from '@/directive/permission/index' // 权限指令
Vue.use(permission)
import GlobalCacheMixin from '@/mixins/GlobalCacheMixin' // 全局页面缓存
Vue.mixin(GlobalCacheMixin)

Vue.use(Element, {
    size: Cookies.get('size') || 'small' // set element-ui default size
})

// register global utility filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Object.defineProperty(Vue.prototype,'$scale',{
  get() {
    return document.documentElement.clientWidth / 1920
  }
})

import NumberUtils from '@/utils/number-utils'
Object.defineProperty(Vue.prototype,'$numberUtils',{
  get() {
    return NumberUtils
  }
})
Object.defineProperty(Vue.prototype,'$parseDate',{
  get() {
    return function parseDate(time) {
      if (!time) {
        return new Date()
      } else {
        if (typeof time === 'string' && time.indexOf('-')) {
          const reg = new RegExp('-', 'gi')
          time = time.replace(reg, '/')
        }
        if (/^[0-9]+$/.test(time)) {
          time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        return new Date(time)
      }
    }
  }
})

Vue.prototype.$duration = 2500

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
